import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { RecommendationData } from "./recommendationSlice";
import { LeasingCommercial } from "./leasingCommercialSlice";
import { DocumentComment } from "./documentCommentSlice";
import { DebtData } from "./debtSlice";
import { stat } from "fs";

interface Summary {
  investmentDescription?: string;
  primaryLeaseType?: string;
  jvPartner?: string;
  assetPlanId?: string;
  investmentId?: string;
  totalCapEx?: number | null;
  bookCostField?: number | null;
  specialPurposeVehicle?: string;
  propertyManagingAgent?: string;
  operator?: string;
  keyPMAOperatorContact?: string;

}

//  public Guid AssetPlanId { get; set; }

//  public string? AssetManagement { get; set; }
//  public string? Leasing { get; set; }
//  public string? Building { get; set; }
//  public string? Sustainability { get; set; }
//  public string? Social { get; set; }
//  public string? Other { get; set; }
//  public string? BreaksExpiries { get; set; }
//  public string? Regears { get; set; }

interface PrioritiesTab {
  assetPlanId?: string;
  assetManagement?: string;
  leasing?: string;
  building?: string;
  sustainability?: string;
  social?: string;
  other?: string;
  breaksExpiries?: string;
  regears?: string;
}




interface KeyAttributes {
  firmName?: string;
  keyContacts?: string;
  email?: string;
  riskRating?: number;
}

interface HoldingStructureAttributes {
  specialPurposeVehicle?: string;
  holdingCompany?: string;
}

interface JvPartnerData {
  assetPlanId?: string;
  jvPartnerFirmName?: string;
  isPartnerDeveloper?: boolean;
  willWorkWithJvPartnerAgain?: boolean;
  keyContact?: string;
  email?: string;
  comments?: string;
  responsiveness?: number;
  reporting?: number;
  flexibility?: number;
  ethics?: number;
  communication?: number;
  collaboration?: number;
  rankComments?: string;
  isJvPartnerAlsoPrM?: boolean;
}

interface PropertyManagerData {
  rfpProcess?: string;
  anotherProperty?: string;
  teamWorkingComments?: string;
  responsiveCommunication?: string;
  incidentManager?: string;
  innovationAndTech?: string;
  riskMitigation?: string;
  timelyReporting?: string;
  tenantRelations?: string;
  vendorSelection?: string;
  prmRankComments?: string;
}

interface keyProvisionData {
  planningAdviser: KeyAttributes;
  buildingContractors: KeyAttributes;
  leasingAgents: KeyAttributes;
  insuranceCompanyDetails: KeyAttributes;
  holdingStructure: HoldingStructureAttributes;
}

interface ThirdPartyInsurer {
  firmName?: string;
  keyContacts?: string;
  email?: string;
  phoneNumber?: number;
}

interface keyProvisionGlobalData {
  assetPlanId?: string;
  planningAdviser?: KeyAttributes;
  buildingContractors?: KeyAttributes;
  leasingAgents?: KeyAttributes;
  propertyManagingAgent?: KeyAttributes;
  operator?: KeyAttributes;
  thirdPartyAssetManager?: KeyAttributes;
  jvPartnerData?: KeyAttributes[];
  holdingStructure?: HoldingStructureAttributes;
  thirdPartyInsurer?: ThirdPartyInsurer;
  hasThirdPartyInsurer?: boolean;
}
interface RecommendationTab {
  assetPlanId?: string;
  recommendations: RecommendationData[];
}
interface CapitalProject {
  projectPriority?: string;
  esgImpact?: boolean;
  comment?: string;
  id?: number;
  projectStartDate?: Date;
  projectEndDate?: Date;
  methodOfFunding?: string;
  additiveToBookCost?: number;
}

interface CapitalProjectData {
  assetPlanId?: string;
  capitalProjects: CapitalProject[];
}
interface DocumentData {
  documents: DocumentComment[];
}
interface CapitalPlanYearData {
  assetPlanId?: string;
  capitalPlanYear?: number;
}
interface SustainabilityDataList {
  data: SustainabilityData[]
}
interface SustainabilityData {
  decarbonizationAssessmentComment?: string
  decarbonizationAssessmentStatusComment?: string
  exposureToAdditionalRegulatory?: string
  complianceStatusComment?: string
  includeCostToProcedure?: string
  includeProjectsComesIntoCompliance?: string
  mitigationPlan?: string
  physicalRiskComment?: string
  regulatoryRiskComment?: string
  ssbbFeatures?: string
  ssbbStandards?: string
  ssbbStandardsComment?: string
  includeCostForStandardEnergyAudit?: string

}

interface Compliance {
  complianceType?: string
  complianceTypeComment?: string
}


interface UpdateDataRequest {
  assetPlanId?: string | null;
  summary?: Summary | null;
  status?: string | null;
  recommendationTab?: RecommendationTab | null;
  capitalProjectData?: CapitalProjectData | null;
  documentData?: DocumentData | null;
  capitalPlanYearData?: CapitalPlanYearData | null;
  occupancyCommercial?: LeasingCommercial | null;
  keyProvisionData?: keyProvisionData | null;
  keyProvisionGlobalData?: keyProvisionGlobalData | null;
  JVsData: JvPartnerData[] | [];
  propertyManagerData: PropertyManagerData | null;
  sustainabilityData?: SustainabilityDataList | null;
  useraction?: string | null;
  debtData?: DebtData | null;
  complianceData?: Compliance | null;
  dateError?: string | null;
  sustainabilityError?: string | null;
  jvstatus?: string | null;
prioritiesTab?: PrioritiesTab | null;  // Change from projectPriority
}




const initialState: UpdateDataRequest = {
  assetPlanId: null,
  summary: null,
  status: null,
  recommendationTab: { assetPlanId: undefined, recommendations: [] },
  capitalProjectData: { assetPlanId: undefined, capitalProjects: [] },
  documentData: { documents: [] },
  keyProvisionData: null,
  keyProvisionGlobalData: null,
  JVsData:[],
  propertyManagerData: null,
  useraction: null,
  occupancyCommercial: null,
  debtData: null,
  sustainabilityData: null,
  complianceData: null,
  dateError: null,
  sustainabilityError: null,
  jvstatus:null,
prioritiesTab: null  // Change from projectPriority

};

const updateDataSlice = createSlice({
  name: "updateData",
  initialState,
  reducers: {
    resetState: (state) => {
      state.assetPlanId = null;
      state.summary = null;
      state.recommendationTab = { assetPlanId: undefined, recommendations: [] };
      state.capitalProjectData = { assetPlanId: undefined, capitalProjects: [] };
      state.documentData = { documents: [] };
      state.keyProvisionData = null;
      state.keyProvisionGlobalData = null;
      state.useraction = null;
      state.occupancyCommercial = null;
      state.debtData = null;
      state.sustainabilityData = null;
      state.complianceData = null;
      state.dateError = null;
      state.sustainabilityError = null;
      state.JVsData = [];
      state.propertyManagerData = null;
      state.jvstatus = null;
state.prioritiesTab = null;  // Change from projectPriority

    },
    updateSummary: (state, action: PayloadAction<Summary>) => {
      state.summary = { ...state.summary, ...action.payload };
    },

 

    updateRecommendation: (
      state,
      action: PayloadAction<RecommendationData & { assetPlanId: any }>
    ) => {
      const { assetPlanId, ...recommendation } = action.payload;
      const existingIndex =
        recommendation.id === 0
          ? state.recommendationTab?.recommendations?.findIndex(
            (rec) =>
              rec.category === recommendation.category &&
              rec.key === recommendation.key
          )
          : state.recommendationTab?.recommendations?.findIndex(
            (rec) => rec.id === recommendation.id
          );

      if (existingIndex !== undefined && existingIndex !== -1) {
        state.recommendationTab!.recommendations[existingIndex] = {
          ...state.recommendationTab!.recommendations[existingIndex],
          ...recommendation,
        };
      } else {
        state.recommendationTab!.recommendations?.push(recommendation);
      }

      state.recommendationTab!.assetPlanId = assetPlanId;
    },

    updatePrioritiesTab: (state, action: PayloadAction<PrioritiesTab>) => {
  state.prioritiesTab = action.payload;  // Change from projectPriority
},


    updateCapitalProject: (state, action: PayloadAction<CapitalProject>) => {
      console.log("inside update slice", action.payload);
      const updatedProject = action.payload;
      const existingProjectIndex =
        state.capitalProjectData?.capitalProjects?.findIndex(
          (project) => project.id === updatedProject.id
        );

      if (existingProjectIndex !== undefined && existingProjectIndex !== -1) {
        state.capitalProjectData!.capitalProjects[existingProjectIndex] = {
          ...updatedProject,
        };
      } else {
        state.capitalProjectData!.capitalProjects.push(updatedProject);
      }
    },
    updateDocumentComment: (state, action: PayloadAction<DocumentComment>) => {
      console.log("inside document slice", action.payload);
      const updatedDoc = action.payload;

      // check if file id of comment being added is already in the slice
      //var isPresent = state.documentData?.documents.some(existingDoc=>existingDoc.id === updatedDoc.id)
      const indexOfFileToUpdate = state.documentData!.documents.findIndex(
        (oldDoc) => oldDoc.id == updatedDoc.id
      );
      //state.documentData?.documents.some(existingDoc=>console.log(existingDoc.id))
      //console.log(isPresent);

      // if item is not in slice so add it
      if (indexOfFileToUpdate === -1) {
        console.log("adding commment...");
        state.documentData!.documents?.push(updatedDoc);
      }
      //if the comment file already exists in updatedataslice, update it
      else {
        console.log("updating comment...");
        state.documentData!.documents[indexOfFileToUpdate] = { ...updatedDoc };
      }
    },
    updateDebtData: (state, action: PayloadAction<DebtData>) => {
      state.debtData = action.payload;
    },
    updateCapitalPlanYear: (
      state,
      action: PayloadAction<CapitalPlanYearData>
    ) => {
      state.capitalPlanYearData = action.payload;
    },
    updateStatus: (state, action: PayloadAction<string>) => {
      console.log("check status", action.payload);
      state.status = action.payload;
    },
    updateAssetPlanId: (state, action: PayloadAction<string>) => {
      console.log("action payload", action.payload);
      state.assetPlanId = action.payload;
    },
    updateLeasingCommercial: (
      state,
      action: PayloadAction<LeasingCommercial>
    ) => {
      state.occupancyCommercial = action.payload;
    },
    updatekeyProvisionData: (state, action: PayloadAction<keyProvisionData>) => {
      state.keyProvisionData = action.payload;
    },
    updatekeyProvisionGlobalData: (state, action: PayloadAction<keyProvisionGlobalData>) => {
      state.keyProvisionGlobalData = action.payload;
    },
    updateJvPartner: (state, action: PayloadAction<JvPartnerData[]>) => {
      state.JVsData = action.payload;
    },
    updatePropertyManager: (state, action: PayloadAction<PropertyManagerData>) => {
      state.propertyManagerData = action.payload;
    },

    updateSustainabilityData: (state, action: PayloadAction<any>) => {
      state.sustainabilityData = action.payload;
    },
    updateComplianceData: (state, action: PayloadAction<any>) => {
      state.complianceData = action.payload;
    },
    setDateError: (state, action: PayloadAction<string>) => {
      state.dateError = action.payload;
    },
    setSustainabilityError: (state, action: PayloadAction<string>) => {
      state.sustainabilityError = action.payload;
    },
    updatedJvStatus: (state, action: PayloadAction<string>) => {
      state.jvstatus = action.payload;
    },
  },
});

export const {
  resetState: resetSaveDataStateAction,
  updateSummary,
  updateRecommendation,
  updateCapitalProject,
  updateDocumentComment,
  updateCapitalPlanYear,
  updateStatus,
  updateAssetPlanId,
  updateLeasingCommercial,
  updatekeyProvisionData,
  updatekeyProvisionGlobalData,
  updateJvPartner,
  updatePropertyManager,
  updateDebtData,
  updateSustainabilityData,
  updateComplianceData,
  setDateError,
  setSustainabilityError,
  updatedJvStatus,
  updatePrioritiesTab

} = updateDataSlice.actions;
export default updateDataSlice.reducer;
